module.exports = __webpack_public_path__ + "static/media/W18-0698_AW_350_Teen_Burger_mobile_hero_FR.968b31ca.jpg";